import React from "react";
import * as PropTypes from "prop-types";
import { Get } from "react-axios";

import { DataProvider } from "./Providers";
import { LinksUrlProvider } from "./UrlProviders";
import { Moment } from "moment";


export class LinksGet extends DataProvider {
  render() {
    const { children, apiUrlProvider, datetime } = this.props;

    return (
      <Get url={apiUrlProvider.getLinksUrl(datetime)} onLoading={this.onLoading} onSuccess={this.onSuccess} onError={this.onError}>
        {(error, response, isLoading, makeRequest, axios) => {
          return typeof children === "function" ? children(error, response, isLoading, makeRequest, axios) : children
        }}
      </Get>
    )
  }
}

LinksGet.propTypes = {
  ...DataProvider.propTypes,
  apiUrlProvider: PropTypes.instanceOf(LinksUrlProvider).isRequired,
  datetime: PropTypes.instanceOf(Moment)
};


export class LinkInfoGet extends DataProvider {
  render() {
    const { children, apiUrlProvider, linkId, datetime } = this.props;

    return (
      <Get url={apiUrlProvider.getLinkInfoUrl(linkId, datetime)} onLoading={this.onLoading} onSuccess={this.onSuccess} onError={this.onError}>
        {(error, response, isLoading, makeRequest, axios) => {
          return typeof children === "function" ? children(error, response, isLoading, makeRequest, axios) : children
        }}
      </Get>
    )
  }
}

LinkInfoGet.propTypes = {
  ...DataProvider.propTypes,
  apiUrlProvider: PropTypes.instanceOf(LinksUrlProvider).isRequired,
  linkId: PropTypes.string.isRequired,
  datetime: PropTypes.instanceOf(Moment)
};
